import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { isArray } from "../../Libs/CustomMethods/customMethods";

import { useDispatch, useSelector } from "react-redux";

import {
  getClientSystem,
  createClientSystem,
  editClientSystem,
  resetClientSystem,
  resetClientSystems,
  resetError,
} from "../../store/actions";

const NewClientSystem = ({ t }) => {
  let { idCompany, idClientSystem } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataClientSystemGetSet,
    dataClientSystemEditCreate,
    loadingClientSystem,
    loadingClientSystemEditCreate,
    successClientSystem,
    errorClientSystem,
  } = useSelector((state) => state.ClientSystems);

  const [clientSystemValues, setClientSystemValues] = useState({
    value: "",
    client_id: "",
    client_system_variable_id: "",
  });

  const [optionsClient, setOptionsClient] = useState([]);
  const [optionsVariable, setOptionsVariable] = useState([]);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleCreateEditClientSystem = () => {
    if (idClientSystem) {
      dispatch(editClientSystem(idClientSystem, newFields));
    } else {
      dispatch(createClientSystem(newFields));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successClientSystem &&
      dispatch(resetClientSystem()) &&
      dispatch(resetClientSystems()) &&
      history.push("/clientsystemvariables"),
  };

  const getOptions = (data) => {
    let options = [];

    if (loadingClientSystemEditCreate) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (data?.length > 0) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        data.map((client, key) =>
          options.push({
            key: key,
            value: client.id,
            label: client.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const handleChangeField = useCallback(
    (value, field) => {
      if (value === clientSystemValues[field]) {
        delete newFields[field];
        checkSubmit();
      } else {
        setNewFields((previous) => ({
          ...previous,
          [field]: value,
        }));
      }
    },
    [clientSystemValues]
  );

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetClientSystem());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idClientSystem) {
      dispatch(getClientSystem(idClientSystem, idCompany, true));
    } else {
      dispatch(getClientSystem(null, null, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idClientSystem]);

  useEffect(() => {
    if (dataClientSystemGetSet?.data) {
      setClientSystemValues((previous) => ({
        ...previous,
        value: dataClientSystemGetSet.data?.data?.value,
        client_id: dataClientSystemGetSet.data?.data?.client_id,
        client_system_variable_id:
          dataClientSystemGetSet.data.data?.client_system_variable_id,
      }));
      setOptionsClient(
        getOptions(
          idClientSystem
            ? dataClientSystemGetSet.data?.form?.clients
            : dataClientSystemGetSet.data?.data?.form?.clients
        )
      );
      setOptionsVariable(
        getOptions(
          idClientSystem
            ? dataClientSystemGetSet.data?.form?.client_system_variable
            : dataClientSystemGetSet.data?.data?.form?.client_system_variable
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClientSystemGetSet]);

  useEffect(() => {
    if (dataClientSystemEditCreate && dataClientSystemEditCreate.message) {
      showToast("success", t(dataClientSystemEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successClientSystem]);

  useEffect(() => {
    if (isArray(errorClientSystem)) {
      errorClientSystem.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorClientSystem) {
        showToast("error", t(errorClientSystem));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorClientSystem]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/clientsystemvariables"
            path={
              idClientSystem
                ? "/clientsystemvariable/" + idClientSystem
                : "/clientsystemvariable"
            }
            title={t("Client System Variables")}
            breadcrumbItem={
              !idClientSystem
                ? t("Create Client System Variable")
                : t("Edit Client System Variable")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditClientSystem}>
                    <Row>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            label={t("Client") + " *"}
                            id="client"
                            name="client"
                            type="select"
                            className="form-control"
                            value={clientSystemValues?.client_id ?? ""}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "client_id")
                            }
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            {optionsClient.map((client, key) => (
                              <option
                                key={key}
                                value={client.value}
                                disabled={client.isDisabled}
                              >
                                {client.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Variable") + " *"}
                            id="variable"
                            name="variable"
                            type="select"
                            className="form-control"
                            value={
                              clientSystemValues?.client_system_variable_id ??
                              ""
                            }
                            onChange={(e) =>
                              handleChangeField(
                                e.target.value,
                                "client_system_variable_id"
                              )
                            }
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            {optionsVariable.map((variable, key) => (
                              <option
                                key={key}
                                value={variable.value}
                                disabled={variable.isDisabled}
                              >
                                {variable.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Value") + " *"}
                            id="value"
                            name="value"
                            type="text"
                            className="form-control"
                            placeholder={t("Client System Variable value")}
                            value={clientSystemValues?.value ?? ""}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "value")
                            }
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingClientSystemEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/clientsystemvariables">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetClientSystem())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewClientSystem);
